import { render, staticRenderFns } from "./charts-dashboard.view.vue?vue&type=template&id=660aa8c2&scoped=true&"
import script from "./charts-dashboard.view.vue?vue&type=script&lang=ts&"
export * from "./charts-dashboard.view.vue?vue&type=script&lang=ts&"
import style0 from "./charts-dashboard.view.vue?vue&type=style&index=0&id=660aa8c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "660aa8c2",
  null
  
)

export default component.exports